export const fileToBase64 = (file: File) =>
	new Promise<string>((resolve, reject) => {
		const reader = new FileReader();

		reader.readAsDataURL(file);

		reader.onload = () => resolve((reader.result as string).replace(/^data.+base64,/gm, ''));
		reader.onerror = () => reject(reader.error);
	});
